import { cn } from '@/shared/cn';
import { vizToneColor, type VizTone } from '@/versions/v1/modules/_viz';

export type SeverityChipProps = {
  label: string;
  tone: VizTone;
  solid?: boolean;
  className?: string;
};

export function SeverityChip({ label, tone, solid = false, className }: SeverityChipProps) {
  const color = vizToneColor(tone);

  if (solid) {
    return (
      <span
        className={cn(
          // Dark theme lifts the state tokens (e.g. --state-warning #FFB547); white text on them fails 1.8:1 — use dark ink there.
          'inline-flex items-center whitespace-nowrap rounded px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-white dark:text-zinc-950',
          className,
        )}
        style={{ backgroundColor: color }}
      >
        {label}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded px-2 py-0.5 text-xs font-semibold uppercase tracking-wide',
        className,
      )}
      style={{
        color,
        backgroundColor: `color-mix(in srgb, ${color} 14%, transparent)`,
      }}
    >
      {label}
    </span>
  );
}
